<template>
    <div class="mb-2">
        <div class="bg-dark flex items-center py-2 px-3 rounded-lg text-white cursor-pointer" @click="$emit('toggle', tyreDetail)">
            <h3 class="font-bold text-xl flex-grow">
                {{ tyreDetail.size }}
            </h3>

            <font-awesome-icon
                class="transition"
                :class="rotateIconClass"
                :icon="['fas', 'angle-left']"
                size="2x"
            ></font-awesome-icon>
        </div>

        <CollapseHeight>
            <div v-if="expand" class="md:flex px-2">
                <div class="basis-1/4 flex flex-wrap justify-center md:block flex-none mt-2">
                    <h3 class="text-dark w-full text-center md:text-left font-bold text-lg mb-4">
                        Tyre label ratings
                    </h3>

                    <div v-for="label of labels" class="mb-4">
                        <TyreLabelRating :type="label" :rating="tyreDetail[label]"></TyreLabelRating>
                    </div>
                </div>
                <div class="flex-grow flex flex-col divide-y divide-grey-200 mt-2">
                    <TyreDetailPriceRow v-for="price of tyreDetail.prices.slice(0, 4)" :price="price"></TyreDetailPriceRow>
                </div>
            </div>
        </CollapseHeight>
    </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import TyreLabelRating from "@/Components/Products/Tyres/TyreLabelRating";
import TyreDetailPriceRow from "@/Components/Products/TyreSizeLookup/TyreDetailPriceRow";
import CollapseHeight from "@/Components/Transitions/CollapseHeight";

export default {
    components: {CollapseHeight, TyreDetailPriceRow, TyreLabelRating, FontAwesomeIcon},
    props: {
        tyreDetail: Object,
        expand: Boolean
    },
    data() {
        return {
            labels: ['fuel', 'wet', 'noise']
        }
    },
    computed: {
        rotateIconClass() {
            return {
                '-rotate-90': this.expand
            }
        }
    }
}
</script>

<style scoped>

</style>
